import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import DataTable from "../../components/DataTable";
import LoadingArea from "../../components/LoadingArea";
import Dashboard from "../../layouts/Dashboard";
import axios from "../../services/axios";
import dateResolve from "../../services/dateResolve";
import isConsultant from "../../services/isConsultant";

function Queries() {
  // Stateful Hooks
  const [loading, setLoading] = useState(true);
  const [queries, setQueries] = useState([]);
  const history = useHistory();

  // Effects and Events
  async function loadQueries() {
    try {
      const { data } = await axios.get("/queries", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setQueries(data);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    loadQueries();
  }, []);

  async function onClickDeleteQuery(e) {
    let id = e.target.getAttribute("query");
    try {
      await axios.delete("queries/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      history.go(0);
    } catch (e) {
      console.error(e);
    }
  }

  function onClickAnswerQuery(e) {
    let id = e.target.getAttribute("query");
    history.push("/queries/" + id);
  }

  return (
    <div>
    {!isConsultant() && <Dashboard title="Queries">
      <LoadingArea isLoading={loading}>
        <div className="mb-4">
          <DataTable
            columns={["title", "candidate", "createdAt"]}
            rows={queries}
            scopes={{
              createdAt: dateResolve,
            }}
            options={(query) => (
              <>
                <button
                  className="btn btn-sm btn-primary"
                  query={query._id}
                  onClick={onClickAnswerQuery}
                  style={{ width: 80 }}
                >
                  <i class="fa fa-edit"></i> Edit
                </button>
                {/* <button className="btn btn-sm mr-1 btn-danger" query={query._id} onClick={onClickDeleteQuery}>
                Delete
              </button> */}
              </>
            )}
          />
        </div>
      </LoadingArea>
    </Dashboard>}
    </div>
  );
}

export default Queries;
